// Mono CTA final — variant swap on tiles, price sync
document.querySelectorAll('.mc').forEach((root) => {
  const select = root.querySelector('[data-mono-cta-select]');
  const priceEl = root.querySelector('[data-mono-cta-price]');
  const tiles = root.querySelectorAll('.mc__tile');
  const radios = root.querySelectorAll('.mc__tile input[type=radio]');
  radios.forEach(r => r.addEventListener('change', () => {
    tiles.forEach(t => t.classList.toggle('is-active', t.contains(r)));
    if (select) select.value = r.dataset.variantId;
    if (priceEl && r.dataset.variantPrice) priceEl.textContent = r.dataset.variantPrice;
  }));
});

// Mono Hero — variant swap, sticky mobile CTA, pointer parallax
document.querySelectorAll('[data-mono-hero]').forEach((root) => {
  const img = root.querySelector('[data-mono-hero-img]');
  const select = root.querySelector('[data-mono-hero-select]');
  const priceEl = root.querySelector('[data-mono-hero-price]');
  const compareEl = root.querySelector('[data-mono-hero-compare]');
  const ctaEl = root.querySelector('[data-mono-hero-cta]');
  const tiles = root.querySelectorAll('.mh__tile');
  const radios = root.querySelectorAll('input[type=radio]');
  const ctaBtn = root.querySelector('.mh__cta');
  const sticky = root.querySelector('[data-mono-hero-sticky]');
  const stickyPrice = root.querySelector('[data-mono-hero-sticky-price]');
  const stickyLabel = root.querySelector('[data-mono-hero-sticky-label]');
  const tiltTarget = root.querySelector('[data-mh-tilt]');

  const updateFromRadio = (radio) => {
    const variantId = radio.dataset.variantId;
    const price = radio.dataset.variantPrice;
    const compare = radio.dataset.variantCompare;
    const label = radio.dataset.variantLabel;
    const imgSrc = radio.dataset.variantImage;
    const img700 = radio.dataset.variantImage_700 || radio.dataset['variantImage-700'];
    const img1100 = radio.dataset.variantImage_1100 || radio.dataset['variantImage-1100'];

    tiles.forEach(t => t.classList.toggle('is-active', t.contains(radio)));

    if (select && variantId) {
      select.value = variantId;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        history.replaceState({}, '', url);
      } catch (_) {}
    }

    if (priceEl && price) priceEl.textContent = price;
    if (ctaEl) ctaEl.textContent = 'Ajouter au panier';
    if (stickyPrice && price) stickyPrice.textContent = price;
    if (stickyLabel && label) stickyLabel.textContent = label;

    if (compareEl) {
      if (compare) {
        compareEl.textContent = compare;
        compareEl.classList.remove('is-hidden');
      } else {
        compareEl.classList.add('is-hidden');
      }
    }

    if (img && imgSrc) {
      img.style.opacity = '0';
      const next = new Image();
      next.onload = () => {
        img.src = imgSrc;
        if (img700 || img1100) {
          const parts = [];
          if (img700) parts.push(`${img700} 700w`);
          if (img1100) parts.push(`${img1100} 1100w`);
          parts.push(`${imgSrc} 1600w`);
          img.srcset = parts.join(', ');
        }
        requestAnimationFrame(() => { img.style.opacity = '1'; });
      };
      next.src = imgSrc;
    }
  };

  radios.forEach(r => r.addEventListener('change', () => updateFromRadio(r)));

  // Sticky mobile CTA visibility
  if (sticky && ctaBtn && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
        sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    observer.observe(ctaBtn);
  }

  // Pointer parallax on the media frame
  if (tiltTarget && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && window.matchMedia('(min-width: 901px)').matches) {
    const media = root.querySelector('.mh__media');
    if (media) {
      let raf = null;
      const onMove = (e) => {
        const rect = media.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          tiltTarget.style.transform = `translate3d(${x * -8}px, ${y * -6}px, 0)`;
        });
      };
      const onLeave = () => {
        if (raf) cancelAnimationFrame(raf);
        tiltTarget.style.transform = '';
      };
      media.addEventListener('pointermove', onMove);
      media.addEventListener('pointerleave', onLeave);
    }
  }
});
